import React from "react";
import { useTranslation } from "react-i18next";
import { Warning } from "@phosphor-icons/react";

export const Disclaimer = ({ className = "", compact }) => {
  const { t } = useTranslation();
  return (
  <div className={`flex items-start gap-2 ${className}`} data-testid="disclaimer">
    {!compact && <Warning size={13} weight="fill" className="mt-0.5 shrink-0" color="rgba(255,255,255,0.35)" />}
    <p className="text-[10px] text-white/35 leading-snug">
      {t("disclaimer.text")}{" "}
      <a href="https://www.joueurs-info-service.fr" target="_blank" rel="noreferrer" className="underline hover:text-white/60">
        {t("disclaimer.help")}
      </a>
    </p>
  </div>
  );
};
